import axiosInstance from '../config/axios';

// GET: Fetch all available facility plans
export const getFacilityPlans = async () => {
    return await axiosInstance.get('/facility-payment-plans');
};

// POST: Subscribe to a selected facility plan
export const subscribeFacilityPlan = async (formData) => {
    return await axiosInstance.post('/facility-subscribe', formData);
};

// POST: Renew to a selected facility plan
export const renewFacilityPlan = async (formData, subscriptionId) => {
    return await axiosInstance.post(`/facility-subscriptions/${subscriptionId}/renew`, formData);
};